import React, { useState } from 'react';

import { Layout } from '@bit/bit.rendering.constants.layouts';
import BitNameId from '@bit/bit.javascript.component.id';
import { Playground } from '../playground';
import { CapsuleType } from '@bit/amit.capsule-dev.remote-capsule';
import { makeFsJson, mainFilePath } from './rendering';

type Props = { bitId: string };

export function StandalonePlayground(props: Props) {
	const { bitId } = props;
	const parsed = bitId && BitNameId.fromBitId(bitId);
	const importSource = parsed && parsed.toNpmId({ includeVersion: false }) + '/dist/examples';

	const [files, setFiles] = useState(() => makeFsJson(CapsuleType.react, importSource));

	return (
		<Playground
			config={{
				layout: Layout.row,
				canWrite: true,
			}}
			example={{
				renderer: CapsuleType.react,
				mainFile: mainFilePath,
				targetComponent: undefined,
				staticUrl: undefined,
				codeId: undefined, // '1',
			}}
			files={files}
			bitId={bitId}
			// overrideFs={fs}
		/>
	);
}
